import { Directive, ElementRef, Input, Output, OnInit, EventEmitter } from '@angular/core';

import { Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';

interface debounceInputConfig {
  delay: number;
  event: string; // 'keyup', 'keydown', etc...
}

/*
it works with input/textarea and [contenteditable]

Usage:
<input (debounceInput)="changeName($event)" [debounceInputConfig]="{delay:500, event:'keyup'}">
or
[debounceInputConfig] is optional, default = {delay: 300, event: 'keyup}

<input (debounceInput)="changeName($event)">
*/

@Directive({
  selector: '[debounceInput]'
})
export class DebounceInputDirective implements OnInit {

  @Input() debounceInputConfig: debounceInputConfig = {
    delay: 500,
    event: 'keyup'
  };

  @Output('debounceInput') value: EventEmitter<string> = new EventEmitter();

  constructor(public el: ElementRef) {
  }

  ngOnInit() {
    if (typeof this.debounceInputConfig.delay === 'undefined') {
      this.debounceInputConfig.delay = 300;
    }

    if (typeof this.debounceInputConfig.event === 'undefined') {
      this.debounceInputConfig.event = 'keyup';
    }

    Observable.fromEvent(this.el.nativeElement, this.debounceInputConfig.event)
      .debounceTime(this.debounceInputConfig.delay)
      .map((event: KeyboardEvent) => {
        const targetElement = <HTMLInputElement>event.target;
        const isInputableField = targetElement.nodeName === 'INPUT' || targetElement.nodeName === 'TEXTAREA';
        const text = isInputableField ? targetElement.value : targetElement.innerText;
        return text;
      })
      .subscribe(text => {
        this.value.emit(text);
      });
  }


}



// WEBPACK FOOTER //
// /codebuild/output/src4281393277/src/src/app/shared/directive/debounce-input.directive.ts